import { Box, Link, List, ListItem, makeStyles, Popover } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import clsx from "clsx";
import { useState } from "react";
import { THEME_MODE } from "src/config/constants";
import { navLinkConfig } from "src/config/constants/layout";

const useStyles = makeStyles((theme) => ({
  box: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
  },
  box1: {
    padding: "0.5rem 0rem 0.5rem 0.25rem",
  },
  title: {
    color: theme.palette.type === THEME_MODE.DARK ? "rgba(255, 255, 255, 0.65)" : "rgba(86, 100, 116, 0.8)",
    fontWeight: 450,
    fontSize: "14px",
    margin: "0px 4px",
    padding: theme.spacing(0, 1.5),
    "&:hover": {
      textDecoration: "none",
      color: theme.palette.text.hint,
    },
  },
  mainTitle: {
    color: theme.palette.primary.main,
    "&:hover": {
      textDecoration: "none",
      color: theme.palette.primary.main,
    },
  },
}));

export default function HeaderTab() {
  const cls = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "more-app-popover" : undefined;

  return (
    <>
      <Box ml={4} flexGrow={1}>
        {navLinkConfig.slice(0, 3).map((element, index) => {
          return (
            <Link
              key={index}
              href={element["link"]}
              className={clsx(cls.title, { [cls.mainTitle]: element["main"] })}
              {...(element.isExternal
                ? {
                    target: "_blank",
                    rel: "noopener",
                  }
                : {})}
            >
              {element["name"]}
            </Link>
          );
        })}
      </Box>
      <Box onClick={(event) => setAnchorEl(event.currentTarget)} className={clsx(cls.title, cls.box)}>
        More
        <MoreHorizIcon />
      </Box>
      <Popover id={id} open={open} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        <List>
          {navLinkConfig.slice(3).map((element, index) => {
            return (
              <ListItem key={index} className={cls.box1}>
                <Link className={clsx(cls.title, { [cls.mainTitle]: element["main"] })} href={element["link"]}>
                  {element["name"]}
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Popover>
    </>
  );
}
